export default {
    title: 'Nutzer',
    email: 'E-Mail',
    phone: 'Telefon',
    customName: 'Anzeigename',
    receive_newsletter_for_international_programs: 'Mitteilungen erhalten',
    receiveNewsletterForInternationalPrograms: 'Mitteilungen erhalten',
    last_login_at: 'Letzter Login',
    firstname: 'Vorname',
    organisationName: 'Organisationsname',
    organisation: 'Organisation',
    role_name: 'Rolle',
    created_at: 'Erstellt am',
    id: 'ID',
    impersonate: 'Support geben',
    emailNotVerified: 'Nutzer wurde noch nicht verifiziert',
    resendEmailVerificationMail: 'E-Mail zur Verifizierung erneut senden',
    qf_onlyEmployees: 'Nur Mitarbeiter',
    qf_onlyNewsletterForInternationalProgramsAccepted: 'Nur Nutzer, die Mitteilungen erhalten möchten',
}